export const PH_CITY_COORDS_MAPVIEW = {
  mandaluyong: [14.5794, 121.0359],
  manila: [14.5995, 120.9842],
  quezon: [14.6760, 121.0437],
  'quezon city': [14.6760, 121.0437],
  makati: [14.5547, 121.0245],
  bgc: [14.5516, 121.0503],
  taguig: [14.5245, 121.0755],
  pasig: [14.5764, 121.0851],
  cebu: [10.3157, 123.8854],
  'cebu city': [10.3157, 123.8854],
  davao: [7.1907, 125.4553],
  'davao city': [7.1907, 125.4553],
  cagayan: [8.4542, 124.6319],
  'cagayan de oro': [8.4542, 124.6319],
  bacolod: [10.6710, 122.9468],
  iloilo: [10.7202, 122.5621],
  angeles: [15.1428, 120.5908],
  'angeles city': [15.1428, 120.5908],
  zamboanga: [6.9214, 122.0790],
  'zamboanga city': [6.9214, 122.0790],
  'general santos': [6.1164, 125.1716],
  gensan: [6.1164, 125.1716],
  batangas: [13.7565, 121.0583],
  'batangas city': [13.7565, 121.0583],
  calamba: [14.2057, 121.1588],
  pampanga: [15.0336, 120.6839],
  bulacan: [14.7926, 120.8821],
  laguna: [14.3000, 121.3000],
  cavite: [14.2360, 120.8825],
  imus: [14.4283, 120.9363],
  paranaque: [14.5066, 121.0052],
  'las pinas': [14.4806, 120.9762],
  muntinlupa: [14.4433, 121.0449],
  valenzuela: [14.7022, 120.9815],
  marikina: [14.6507, 121.1029],
  'san fernando': [15.0286, 120.6898],
  'santa rosa': [14.3150, 121.1081],
  calapan: [13.4147, 121.1791],
  'puerto princesa': [9.7392, 118.7353],
  tacloban: [11.2543, 125.0090],
  roxas: [11.5854, 122.7544],
  bacolodcity: [10.6710, 122.9468],
  dumaguete: [9.3069, 123.3044],
  dipolog: [8.5859, 123.3395],
  cotabato: [7.2210, 124.2432],
  pagadian: [7.8271, 123.4314],
  ozamiz: [8.1517, 123.8432],
  ormoc: [11.0061, 124.6057],
  bacoor: [14.4774, 120.9447],
  'san pablo': [14.0795, 121.3299],
  lucena: [13.9373, 121.6156],
  naga: [13.6218, 123.1948],
  legazpi: [13.1352, 123.7464],
  metro: [14.5995, 120.9842],
  ncr: [14.5995, 120.9842],
  'metro manila': [14.5995, 120.9842],
  'national capital region': [14.5995, 120.9842],
  manilanCR: [14.5995, 120.9842],
  'head office': [14.5547, 121.0245],
  headoffice: [14.5547, 121.0245],
  hq: [14.5547, 121.0245],
  office: [14.5547, 121.0245],
  main: [14.5547, 121.0245],
  central: [14.5547, 121.0245],
  ortigas: [14.5858, 121.0619],
  'ortigas center': [14.5858, 121.0619],
  cubao: [14.6186, 121.0565],
  alabang: [14.4153, 121.0402],
  ayala: [14.5547, 121.0245],
  eastwood: [14.6064, 121.0789],
  clark: [15.1860, 120.5614],
  baguio: [16.4023, 120.5960],
  subic: [14.8088, 120.2716],
  olongapo: [14.8267, 120.2833],
};

export const ymdLocal = (d) => {
  if (!(d instanceof Date) || Number.isNaN(d.getTime())) return null;
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${m}-${day}`;
};

export const tryFieldAny = (c) => {
  if (c == null || c === '') return NaN;
  if (typeof c === 'number') return c;
  if (typeof c === 'boolean') return NaN;
  if (typeof c === 'string') {
    if (/^\d{10,13}$/.test(c)) {
      const n = Number(c);
      return n < 1e12 ? n * 1000 : n;
    }
    return new Date(c).getTime();
  }
  if (c instanceof Date) return c.getTime();
  if (typeof c === 'object') {
    if (typeof c.$date === 'string') return new Date(c.$date).getTime();
    if (typeof c.$date === 'number') return c.$date;
    if (typeof c.sec === 'number' || typeof c.seconds === 'number') {
      const sec = c.sec ?? c.seconds;
      return sec * 1000;
    }
    if (typeof c.ms === 'number' || typeof c.milliseconds === 'number') {
      return c.ms ?? c.milliseconds;
    }
    if (typeof c.time === 'string') return new Date(c.time).getTime();
    if (typeof c.iso === 'string') return new Date(c.iso).getTime();
  }
  return NaN;
};

export const extractTimestampMillis = (r) => {
  if (!r) return 0;
  const candidates = [
    r.time_in, r.time_out, r.time_in_at, r.time_out_at,
    r.check_in_time, r.check_out_time, r.checkin_time, r.checkout_time,
    r.clock_in_time, r.clock_out_time, r.clockin, r.clockout,
    r.signInTime, r.signOutTime, r.sign_in_time, r.sign_out_time,
    r.login_time, r.logout_time, r.loginTime, r.logoutTime,
    r.punch_time, r.punchTime, r.punch_in_time, r.punch_out_time,
    r.activity_time, r.attendance_time, r.event_time, r.posted_at,
    r.server_time, r.logged_at, r.recorded_at, r.verified_at,
    r.attendance_date, r.shift_date, r.work_date, r.date_of_record,
    r.timestamp, r.date, r.datetime, r.date_time, r.time,
    r.created_at, r.createdAt, r.updated_at, r.updatedAt, r.modified_at,
    r.submitted_at, r.received_at, r.inserted_at, r.created,
    tryFieldAny(typeof r.timestamp === 'object' && r.timestamp != null ? r.timestamp : null),
    tryFieldAny(typeof r.created_at === 'object' && r.created_at != null ? r.created_at : null),
    tryFieldAny(typeof r.time_in === 'object' && r.time_in != null ? r.time_in : null),
    tryFieldAny(typeof r.check_in_time === 'object' && r.check_in_time != null ? r.check_in_time : null),
    tryFieldAny(typeof r.login_time === 'object' && r.login_time != null ? r.login_time : null),
    tryFieldAny(typeof r.attendance_date === 'object' && r.attendance_date != null ? r.attendance_date : null),
  ];
  for (const raw of candidates) {
    const ms = tryFieldAny(raw);
    if (Number.isFinite(ms) && ms > 946684800000) return ms;
  }
  try {
    for (const [k, v] of Object.entries(r || {})) {
      if (!k || v == null || v === '') continue;
      const lower = k.toLowerCase();
      const isTimey =
        lower.includes('time') || lower.includes('date') || lower.includes('stamp') ||
        lower.includes('_at') || lower.endsWith('_on') || lower.includes('created') ||
        lower.includes('updated') || lower.includes('logged') || lower.includes('posted') ||
        lower.includes('clock') || lower.includes('punch') || lower.includes('sign');
      if (!isTimey) continue;
      const ms = tryFieldAny(v);
      if (Number.isFinite(ms) && ms > 946684800000) return ms;
    }
  } catch { /* no-op */ }
  return 0;
};

export const isLoginTypeRecord = (r) => {
  if (!r) return false;
  const t = (r.type || '').toString().toLowerCase().trim();
  const a = (r.action || '').toString().toLowerCase().trim();
  const s = (r.status || '').toString().toLowerCase().trim();
  const ev = (r.event || '').toString().toLowerCase().trim();
  const activity = (r.activity || '').toString().toLowerCase().trim();
  const loginPhrases = [
    'time_in', 'timein', 'time in', 'check_in', 'checkin', 'check in',
    'login', 'log in', 'sign_in', 'signin', 'sign in',
    'punch_in', 'punchin', 'punch in', 'in', 'on_duty', 'on duty',
    'start', 'clock_in', 'clockin', 'clock in', 'arrive', 'arrival',
    'enter', 'entry', 'first_in', 'first login', 'time-in', 'check-in',
    'sign-in', 'punch-in', 'start_shift', 'start shift', 'present',
  ];
  for (const p of loginPhrases) {
    if (t.includes(p) || a.includes(p) || s.includes(p) || ev.includes(p) || activity.includes(p)) return true;
  }
  const explicitLogoutPhrases = [
    'time_out', 'timeout', 'time out', 'time-out', 'check_out', 'checkout',
    'check out', 'check-out', 'logout', 'log out', 'sign_out', 'signout',
    'sign out', 'sign-out', 'punch_out', 'punchout', 'punch out', 'punch-out',
    'clock_out', 'clockout', 'clock out',
  ];
  if (a === 'out') return false;
  for (const p of explicitLogoutPhrases) {
    if (t.includes(p) || a.includes(p) || ev.includes(p) || activity.includes(p)) return false;
  }
  const hasCoords =
    typeof r.latitude === 'number' || typeof r.longitude === 'number' ||
    typeof r.lat === 'number' || typeof r.lng === 'number' ||
    (r.coords && (typeof r.coords.latitude === 'number' || typeof r.coords.lat === 'number')) ||
    (r.gps && (typeof r.gps.latitude === 'number' || typeof r.gps.lat === 'number')) ||
    (r.location && (typeof r.location.lat === 'number' || typeof r.location.latitude === 'number'));
  const hasLocText =
    (typeof r.location === 'string' && r.location.trim()) ||
    (typeof r.city_name === 'string' && r.city_name.trim()) ||
    (typeof r.address === 'string' && r.address.trim()) ||
    (typeof r.branch === 'string' && r.branch.trim()) ||
    (typeof r.office === 'string' && r.office.trim());
  const hasTs = extractTimestampMillis(r) > 0;
  if (hasTs && (hasCoords || hasLocText)) return true;
  return false;
};

export const isLogoutTypeRecord = (r) => {
  if (!r) return false;
  const t = (r.type || '').toString().toLowerCase().trim();
  const a = (r.action || '').toString().toLowerCase().trim();
  const s = (r.status || '').toString().toLowerCase().trim();
  const ev = (r.event || '').toString().toLowerCase().trim();
  const activity = (r.activity || '').toString().toLowerCase().trim();
  const phrases = [
    'time_out', 'timeout', 'time out', 'check_out', 'checkout', 'check out',
    'logout', 'log out', 'sign_out', 'signout', 'sign out',
    'punch_out', 'punchout', 'punch out', 'out', 'off_duty', 'off duty',
    'end', 'clock_out', 'clockout', 'clock out', 'depart', 'departure',
    'exit', 'leave', 'time-out', 'check-out', 'sign-out', 'punch-out',
    'end_shift', 'end shift',
  ];
  for (const p of phrases) {
    if (t.includes(p) || a.includes(p) || s.includes(p) || ev.includes(p) || activity.includes(p)) return true;
  }
  return false;
};

export const extractLoginsPerDay = (records, forceTodayKey = undefined) => {
  const logins = (records || []).filter((r) => isLoginTypeRecord(r));
  const byDay = new Map();
  logins.forEach((r) => {
    const ms = extractTimestampMillis(r);
    if (!ms) return;
    const ts = new Date(ms);
    const key = ymdLocal(ts);
    if (!key) return;
    const prev = byDay.get(key);
    if (!prev) { byDay.set(key, r); return; }
    const prevTime = extractTimestampMillis(prev);
    const curTime = ms;
    if (curTime < prevTime) byDay.set(key, r);
  });
  const sortedDays = [...byDay.keys()].sort().reverse();
  const todayKey = forceTodayKey || ymdLocal(new Date());
  const latestOverall = sortedDays[0] ? byDay.get(sortedDays[0]) : null;
  const todayLatest = (todayKey && byDay.has(todayKey)) ? byDay.get(todayKey) : null;
  return { sortedDays, byDay, latestOverall, todayLatest };
};

export const pickLocationCity = (cityNameOrText, PH_CITY_COORDS = PH_CITY_COORDS_MAPVIEW) => {
  if (!cityNameOrText || typeof cityNameOrText !== 'string') return [null, null];
  const txt = cityNameOrText.toLowerCase().trim();
  if (!txt) return [null, null];
  const direct = PH_CITY_COORDS[txt];
  if (Array.isArray(direct) && direct.length >= 2 && typeof direct[0] === 'number' && typeof direct[1] === 'number') {
    return [direct[0], direct[1]];
  }
  const entry = Object.entries(PH_CITY_COORDS).find(([name]) => txt.includes(name));
  if (entry && Array.isArray(entry[1]) && entry[1].length >= 2) {
    return [entry[1][0], entry[1][1]];
  }
  return [null, null];
};

export const hasTodayLoginInBucket = (bucketRecs, todayKey) => {
  if (!bucketRecs || !bucketRecs.length || !todayKey) return false;
  for (const r of bucketRecs) {
    if (!isLoginTypeRecord(r)) continue;
    const ms = extractTimestampMillis(r);
    if (!ms) continue;
    if (ymdLocal(new Date(ms)) === todayKey) return true;
  }
  return false;
};
